import { render, staticRenderFns } from "./RefPayed.vue?vue&type=template&id=022eee30&scoped=true&"
import script from "./RefPayed.vue?vue&type=script&lang=js&"
export * from "./RefPayed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022eee30",
  null
  
)

export default component.exports